const Slider = (function(window, $) {
    let Swiper;

    function Sliders(target) {

        //Loop over elements, to make multiple slider of the same type possible
        $(target).each(function(index, el) {
            let numberOfSlides = $(this).find('.swiper-slide').length;
            let autoPlay = 5000;
            let spaceBetween = 24;
            let centered = $(this).data('centered');
            let swiperConfig;

            /**
             * Gallery slider
             */
            if($(this).hasClass('swiper-gallery-slider')) {
                //Centered will start the slider in the middle. Loop the slides to fill whitespace on the left
                //Only center slides if uneven number slides and there or more slides than max visible in screen
                let centeredSlides = centered && numberOfSlides % 2 !== 0 && numberOfSlides > 1;
                spaceBetween = centeredSlides ? 0 : spaceBetween; //Remove space between if slides are centered

                swiperConfig = {
                    spaceBetween: spaceBetween,
                    centeredSlides: centeredSlides, //if uneven, center slides
                    watchOverflow: true,
                    autoplay: {
                        delay: autoPlay,
                    },
                    navigation: {
                        nextEl: $(this).closest('.section-gallery').find('.swiper-button-next'),
                        prevEl: $(this).closest('.section-gallery').find('.swiper-button-prev'),
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    slidesPerView: 'auto'
                };
            }


            /**
             * Quote slider
             */
            if(numberOfSlides > 0 && $(this).hasClass('quotes-list-grid')) {
                swiperConfig = {
                    direction: 'horizontal',
                    loop: numberOfSlides > 1,
                    watchOverflow: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    autoplay: {
                        delay: autoPlay,
                    },
                    navigation: {
                        nextEl: $(this).closest('.section-quotes-list').find('.swiper-button-next'),
                        prevEl: $(this).closest('.section-quotes-list').find('.swiper-button-prev'),
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    on: {
                        init: function () {
                            setTimeout(this.update.bind(this), 2000); // Needed for critical CSS support (dirty fix)
                        }
                    }

                };
            }

            /**
             * Featured slider
             */
            if(numberOfSlides > 1 && $(this).hasClass('featured-list-grid')) {
                swiperConfig = {
                    direction: 'horizontal',
                    lazy: {
                        loadPrevNext: true
                    },
                    loop: numberOfSlides > 1,
                    watchOverflow: true,
                    autoplay: {
                        delay: 10000,
                    },
                    navigation: {
                        nextEl: $(this).parent().find('.swiper-button-next'),
                        prevEl: $(this).parent().find('.swiper-button-prev'),
                    },
                    pagination: {
                        el: $(this).parent().find('.swiper-pagination'),
                        clickable: true
                    },

                };
            }

            /**
             * Author slider
             */
            if($(this).hasClass('swiper-authors')) {
                swiperConfig = {
                    speed: 800,
                    grabCursor: true,
                    watchOverflow: true,
                    spaceBetween: 16,
                    freeMode: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: $(this).closest('.section-authors').find('.swiper-button-next'),
                        prevEl: $(this).closest('.section-authors').find('.swiper-button-prev'),
                    },
                    slidesPerView: 'auto',
                    breakpoints: {
                        601: {
                            spaceBetween: spaceBetween
                        }
                    }
                };
            }

            /**
             * Search menu slider
             */
            if(numberOfSlides > 1 && $(this).hasClass('swiper-menu')) {
                swiperConfig = {
                    freeMode: true,
                    slidesPerView: 'auto',
                    watchOverflow: true,
                    spaceBetween: 0
                };
            }

            /**
             * Article slider
             */
            if($(this).hasClass('article-list-grid')) {
                swiperConfig = {
                    direction: 'horizontal',
                    loop: false,
                    spaceBetween: spaceBetween,
                    watchOverflow: true,
                    navigation: {
                        nextEl: $(this).closest('.section-article-list').find('.swiper-button-next'),
                        prevEl: $(this).closest('.section-article-list').find('.swiper-button-prev'),
                    },
                    slidesPerView: 'auto'
                };
            }

            if($(this).hasClass('book-list-grid')) {
                swiperConfig = {
                    direction: 'horizontal',
                    loop: false,
                    spaceBetween: spaceBetween,
                    watchOverflow: true,
                    navigation: {
                        nextEl: $(this).closest('.book-list-container').find('.swiper-button-next'),
                        prevEl: $(this).closest('.book-list-container').find('.swiper-button-prev'),
                    },
                    slidesPerView: 'auto'
                };
            }

            if (themeSettings.related_downloads.swiper_enabled == true) {
                if($(this).hasClass('download-list-container')) {
                    swiperConfig = {
                        direction: 'horizontal',
                        autoplay: {
                            delay: 3500,
                        },
                        loop: false,
                        freeMode: true,
                        watchOverflow: true,
                        spaceBetween: spaceBetween,
                        navigation: {
                            nextEl: $(this).closest('.section-download-list').find('.swiper-button-next'),
                            prevEl: $(this).closest('.section-download-list').find('.swiper-button-prev'),
                        },
                        slidesPerView: 'auto'
                    };
                }
            }

            const swiperPromise = import('swiper')
                .then( ( swiperImport ) => swiperImport.default )
                .then( ( resolvedSwiper ) => Swiper = resolvedSwiper );

            Promise.all([StateManager.stylesheetsLoaded, StateManager.criticalCssRemoved, swiperPromise])
                .then(() => {
                    if($(swiperConfig).length > 0) {
                        swiperInit(this, swiperConfig);
                    }
                });

        });


        const swiperInit = function(el, swiperConfig) {
            let swiperEl;

            /**
             * Initialize Swiper Element
             */
            const enableSwiper = () => {
                swiperEl = new Swiper(el, swiperConfig);
                swiperElements.push(swiperEl);
            };

            /**
             * Destroy Swiper Element
             */
            const destroySwiper = () => {
                if (swiperEl !== undefined) {
                    swiperEl.destroy(true, true);
                }
            }

            if(swiperConfig.init_breakpoint !== undefined) {
                let initBreakpoint = swiperConfig.init_breakpoint;
                let mediaBreakPoint = window.matchMedia(
                    '(min-width:'+initBreakpoint.min+'px) and (max-width:'+initBreakpoint.max+'px)'
                );

                /**
                 * Handle Media Query if init_breakpoint is set.
                 * Destroy / Enable swiper based on init_breakpoints
                 */
                const handleMediaQuery = () => {
                    if ( mediaBreakPoint.matches === false ) {
                        return destroySwiper();
                    } else if (mediaBreakPoint.matches === true) {
                        return enableSwiper();
                    }
                }

                //Check media query on screen resize
                window.addEventListener('resize', handleMediaQuery);

                //Check media query on page load
                handleMediaQuery();
            } else {
                enableSwiper();
            }
        };
    }

    return Sliders;

}(window, jQuery));

export {Slider};
